import { TextFieldLight } from "../../../common/components/styled/styled";
import { TableCell, TableRow, styled } from "@mui/material";

// Define the StyledTableCell with custom padding
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.7),
  alignItems: "center",
  borderBottom: "none",
}));

// Define the StyledTableRow to remove bottom border
export const StyledTableRow = styled(TableRow)({
  "&:last-child td, &:last-child th": {
    borderBottom: "none",
  },
});

export const gridUnionNameStyles = {
  border: "1px solid #ccc",
  borderRadius: "6px",
  padding: "8px",
  fontSize: "14px",
  color: "#4A1D9C",
  background: "#fbfbfc",
  margin: "8px",
  cursor: "pointer",
};

export const gridUnionNumberStyles = {
  border: "1px solid #ccc",
  borderRadius: "6px",
  padding: "8px",
  fontSize: "14px",
  color: "rgba(0, 0, 0, 0.38)",
  background: "#fbfbfc",
  margin: "8px",
};

export const headerStyles = {
  padding: "8px",
};

export const StyledTextField = (props: any) => (
  <TextFieldLight size="small" sx={{ width: "50%" }} {...props} />
);
